export type WorkingFacilityCountsPayload = {
	facilityId: number;
	watchedRuns: number | null;
};

export type WorkingFacilityCountsFetchedAction = {
	type: 'WORKING_FACILITY_COUNTS_FETCHED';
	payload: WorkingFacilityCountsPayload;
};

export default (payload: WorkingFacilityCountsPayload): WorkingFacilityCountsFetchedAction => ({
	type: 'WORKING_FACILITY_COUNTS_FETCHED',
	payload,
});
